<template>
  <div class="invitation-details">
    <a-spin tip="加载中..." :spinning="loading">
      <a-row :gutter="[16, 16]" type="flex" align="middle" class="info">
        <a-col>
          <dy-image :src="info.avatar"></dy-image>
        </a-col>
        <a-col flex="1">
          <a-space direction="vertical">
            <p class="name">{{info.nickname}}</p>
            <p>{{info.created_at}}</p>
          </a-space>
        </a-col>
      </a-row>
      <a-row :gutter="[16, 16]">
        <a-col>
          <p>#{{info.category}}# {{info.content}}</p>
        </a-col>
      </a-row>
      <a-row :gutter="[16, 16]" type="flex" class="pics" v-viewer>
        <a-col v-for="value in info.photos" :key="value" span="6">
          <dy-image :src="value"></dy-image>
        </a-col>
      </a-row>
      <a-row type="flex" class="btns">
        <a-popover title="评论" v-model="note.show" trigger="click">
          <template slot="content">
            <a-textarea v-model="note.value" placeholder="请输入评论"></a-textarea>
            <a-space>
              <a-button type="link" @click="commentInvitation">提交</a-button>
            </a-space>
          </template>
          <a-col span="6">评论({{info.comment_times}})</a-col>
        </a-popover>
        <a-col span="6" @click="likeInvitation" v-if="!info.is_like">点赞({{info.like_times}})</a-col>
        <a-col span="6" @click="likeInvitation" v-else>取消点赞({{info.like_times}})</a-col>
        <a-col span="6" @click="topInvitation" v-if="!info.is_top">置顶</a-col>
        <a-col span="6" @click="cancelTopInvitation" v-else>取消置顶</a-col>
        <a-col span="6" @click="enableInvitation" v-if="info.is_hide">显示</a-col>
        <a-col span="6" @click="disableInvitation" v-else>隐藏</a-col>
      </a-row>
      <comment-details :community-id="communityId" :init-data="data" :init-page="initPage"></comment-details>
    </a-spin>
    <a-pagination v-model="page.current" :page-size="page.pageSize" :total="page.total" @change="handleChangePagination" v-if="data.length"></a-pagination>
  </div>
</template>

<script>
  import InvitationService from '@/io/invitation.js';
  import CommentDetails from '@/views/community/CommentDetails.vue';

  export default {
    name: 'InvitationDetails',
    props: {
      id: {
        type: Number,
        default: null
      },
      communityId: {
        type: Number,
        default: null
      },
    },
    data() {
      return {
        info: {},
        note: {
          value: null,
          show: false
        },
        data: [],
        loading: false,
        page: {
          current: 1,
          total: 1,
          pageSize: 10,
        }
      }
    },
    components: {
      CommentDetails,
    },
    watch: {
      id: {
        handler(newValue, oldValue) {
          if (newValue) {
            this.initPage();
          }
        },
        immediate: true
      }
    },
    methods: {
      initPage() {
        this.loading = true;
        InvitationService.info(this.id, this.page.current, this.page.pageSize).then(res => {
          this.info = res.meta.posts;
          this.data = res.data;
          this.page.total = res.meta.pagination.total;
        }).catch(err => {}).finally(() => {
          this.loading = false;
        });
      },
      topInvitation() {
        InvitationService.top(this.id).then(res => {
          this.initPage();
        }).catch(err => {});
      },
      cancelTopInvitation() {
        InvitationService.cancelTop(this.id).then(res => {
          this.initPage();
        }).catch(err => {});
      },
      enableInvitation() {
        InvitationService.enable(this.id).then(res => {
          this.initPage();
        }).catch(err => {});
      },
      disableInvitation() {
        InvitationService.disable(this.id).then(res => {
          this.initPage();
        }).catch(err => {});
      },
      likeInvitation() {
        InvitationService.like(this.id).then(res => {
          this.initPage();
        }).catch(err => {});
      },
      commentInvitation() {
        if (this.note.value) {
          InvitationService.comment(this.communityId, this.id, this.note.value).then(res => {
            this.initPage();
          }).catch(err => {}).finally(() => {
            this.note.value = null;
            this.note.show = false;
          });
        } else {
          this.$message.error('请输入评论');
        }
      },
      handleChangePagination(page, pageSize) {
        this.page.current = page;
        this.page.pageSize = pageSize;
        this.initPage();
      },
    },
  }
</script>

<style lang="less" scoped>
  @import '../../assets/styles/tools.less';
  .invitation-details {
    .info {
      .dy-image {
        width: 50px;
        height: 50px;
      }
      .name {
        font-weight: bold;
      }
    }
    .pics {
      .dy-image {
        width: 100%;
      }
    }
    .btns {
      text-align: center;
      margin: @padding-sm 0;
      .ant-col {
        cursor: pointer;
        &:not(:last-of-type) {
          border-right: 1px solid @border-color-split;
        }
        &:hover {
          color: @primary-color;
        }
      }
    }
    .ant-pagination {
      margin-top: @padding-lg;
      text-align: right;
    }
  }
</style>